<script>
import consentService from '@services/consent-service'
import BaseButton from './_base-button'
import { isIosBrowser } from '@utils/user-agent'

export default {
    name: 'ConsentBanner',
    components: {
        BaseButton
    },
    data() {
        return {
            isVisible: true,
            showAboveBanner: isIosBrowser(),
        }
    },
    mounted() {
        document.addEventListener('keydown', this.handleKeydown)
        document.addEventListener('click', this.handleDocumentClick, true)
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleKeydown)
        document.removeEventListener('click', this.handleDocumentClick, true)
    },
    methods: {
        handleAgree() {
            consentService.grantConsent('banner')
            this.$emit('close')
        },
        handleTemporaryDismiss() {
            this.isVisible = false
            consentService.temporarilyDismiss()
        },
        handleKeydown(event) {
            if (event.key === 'Escape') {
                this.handleTemporaryDismiss()
            }
        },
        handleDocumentClick(event) {
            if (this.isVisible && this.$refs.banner && !this.$refs.banner.contains(event.target)) {
                this.handleTemporaryDismiss()
            }
        }
    }
}
</script>

<template>
    <div
        v-if="isVisible"
        ref="banner"
        :class="[$style.banner, showAboveBanner && $style.aboveSmartBanner]"
        role="dialog"
        aria-modal="false"
        aria-label="Privacy consent"
    >
        <p :class="$style.text">
            By using this site, you agree to our
            <a
                :class="$style.link"
                href="https://frisky.fm/about/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
            >Privacy Policy</a>.
        </p>
        <BaseButton
            button-type="secondaryPink"
            size="small"
            :modifiers="{ noMargins: true }"
            @click="handleAgree"
        >
            I agree
        </BaseButton>
    </div>
</template>

<style lang="scss" module>
@use '@design' as *;

.banner {
    position: fixed;
    bottom: $s-m;
    left: 50%;
    z-index: $layer-modal-z-index + 2;
    display: flex;
    gap: $s-l;
    align-items: center;
    justify-content: space-between;
    width: calc(100% - #{$s-m} * 2);
    padding: $s-l;
    background-color: $c-shark-grey;
    border-radius: $size-input-border-radius;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
    transform: translateX(-50%);
}

.text {
    @extend %contentSubtitleM;

    margin: 0;
    color: $c-white;
}

.link {
    color: $c-white;
    text-decoration: underline;

    &:hover {
        color: $c-highlight;
    }
}

.aboveSmartBanner {
    bottom: calc(#{$s-m} + #{$size-smart-banner-height} + env(safe-area-inset-bottom, 0));
}

@include desktop {
    .banner {
        right: $s-xl;
        bottom: $s-xl;
        left: auto;
        width: auto;
        max-width: 480px;
        transform: none;
    }
}
</style>
